const CUSTOMER_APP_ID_HEADER = 'customer-app-id';
const CONFIGURATION_NAME_HEADER = 'customer-config-id';
const BRAND_NAME = 'Atto';
const CONNECT_BEARER = 'connect-bearer';
const CIS_ACCOUNT_BEARER = 'cis-account-bearer';
const CIS_ACCOUNTS = 'cis-accounts';

export {
  CUSTOMER_APP_ID_HEADER,
  CONFIGURATION_NAME_HEADER,
  BRAND_NAME,
  CONNECT_BEARER,
  CIS_ACCOUNT_BEARER,
  CIS_ACCOUNTS
};
